// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__lirHk","large":"styles_large__St4Jo"};